/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * sim_table.csvのデータ
 * @export
 * @interface SimTableData
 */
export interface SimTableData {
    /**
     * ダムあり最大流量
     * @type {number}
     * @memberof SimTableData
     */
    maxFlowDam?: number;
    /**
     * ダムなし最大流量
     * @type {number}
     * @memberof SimTableData
     */
    maxFlowNodam?: number;
    /**
     * ダムあり最大水位
     * @type {number}
     * @memberof SimTableData
     */
    maxWlevelDam?: number;
    /**
     * ダムなし最大水位
     * @type {number}
     * @memberof SimTableData
     */
    maxWlevelNodam?: number;
    /**
     * 洪水調節効果（流量）
     * @type {number}
     * @memberof SimTableData
     */
    floodControlEffectFlow?: number;
    /**
     * 洪水調節効果（水位）
     * @type {number}
     * @memberof SimTableData
     */
    floodControlEffectWlevel?: number;
}

/**
 * Check if a given object implements the SimTableData interface.
 */
export function instanceOfSimTableData(value: object): value is SimTableData {
    return true;
}

export function SimTableDataFromJSON(json: any): SimTableData {
    return SimTableDataFromJSONTyped(json, false);
}

export function SimTableDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SimTableData {
    if (json == null) {
        return json;
    }
    return {
        
        'maxFlowDam': json['max_flow_dam'] == null ? undefined : json['max_flow_dam'],
        'maxFlowNodam': json['max_flow_nodam'] == null ? undefined : json['max_flow_nodam'],
        'maxWlevelDam': json['max_wlevel_dam'] == null ? undefined : json['max_wlevel_dam'],
        'maxWlevelNodam': json['max_wlevel_nodam'] == null ? undefined : json['max_wlevel_nodam'],
        'floodControlEffectFlow': json['flood_control_effect_flow'] == null ? undefined : json['flood_control_effect_flow'],
        'floodControlEffectWlevel': json['flood_control_effect_wlevel'] == null ? undefined : json['flood_control_effect_wlevel'],
    };
}

export function SimTableDataToJSON(json: any): SimTableData {
    return SimTableDataToJSONTyped(json, false);
}

export function SimTableDataToJSONTyped(value?: SimTableData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'max_flow_dam': value['maxFlowDam'],
        'max_flow_nodam': value['maxFlowNodam'],
        'max_wlevel_dam': value['maxWlevelDam'],
        'max_wlevel_nodam': value['maxWlevelNodam'],
        'flood_control_effect_flow': value['floodControlEffectFlow'],
        'flood_control_effect_wlevel': value['floodControlEffectWlevel'],
    };
}

